import { FC, useMemo } from "react";
import { Button } from "@shared/components";
import { IconButton } from "@shared/components/icon-button";
import CloseRemoveIcon from "@svg/new-design/close-remove";
import { BUTTON_SIZE, BUTTON_VARIANT } from "@shared/components/button/types";
import {
  ICON_COLOR,
  ICON_SIZE,
  ICON_VARIANT,
} from "@shared/components/icon-button/types";
import classNames from "classnames";
import { COUPON_STATUS } from "./types";
import { styleMap } from "./constants";

interface Props {
  message: string;
  isHome: boolean;
  isProfile: boolean;
  isAdmin: boolean;
  onMoreClick: () => void;
  onClose: () => void;
  status: COUPON_STATUS;
}

export const CopounHeaderContent: FC<Props> = ({
  message,
  isAdmin,
  isHome,
  isProfile,
  onMoreClick,
  onClose,
  status,
}) => {
  const styles = useMemo(() => {
    return styleMap[status];
  }, [status]);
  const Icon = styles.icon;

  return (
    <div
      className={classNames(
        isAdmin ? "top-fds-120" : "top-20",
        styles.bg,
        styles.text,
        isHome
          ? "z-layout right-1/2 translate-x-1/2 transform rounded-8 lg:w-3/4 sm:w-3/4 w-5/6 fixed"
          : isProfile
            ? "rounded-8"
            : "",
        "flex flex-col md:flex-row justify-between md:items-center p-4 body-lg"
      )}
    >
      <div className="flex gap-2 items-center">
        <Icon className={classNames("min-h-6 min-w-6", styles.iconColor)} />
        <p className={classNames("title-md-medium", styles.text)}>{message}</p>
      </div>

      <div className="flex gap-x-2 items-center justify-end">
        <Button
          size={BUTTON_SIZE.MEDIUM}
          variant={BUTTON_VARIANT.OUTLINE}
          color={styles.buttonColor}
          onClick={onMoreClick}
          className="min-w-fit"
        >
          اطلاعات بیشتر
        </Button>

        <IconButton
          icon={<CloseRemoveIcon />}
          variant={ICON_VARIANT.DEFAULT}
          color={ICON_COLOR.WARNING}
          size={ICON_SIZE.SMALL}
          iconClassName={classNames("h-5 w-5 mr-1.5", styles.iconColor)}
          onClick={onClose}
          aria-label="اطلاعات بیشتر"
        />
      </div>
    </div>
  );
};
